/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicAmazonCatalogue.internal

import features.publicAmazonCatalogue.models.PublicRewardsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.publicAmazonCatalogue.internal.PublicAmazonCatalogueUseCase.Params

internal class PublicAmazonCatalogueUseCase : AsyncUseCase<PublicRewardsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val pageNumber: Int,
        val perPage: Int,
        val keywords: String?,
        val filters: String?
    )

    private val publicAmazonCatalogueService: PublicAmazonCatalogueService = PublicAmazonCatalogueServiceImpl()

    override suspend fun run(params: Params): Result<PublicRewardsModel> {
        return publicAmazonCatalogueService.getPublicAmazonCatalogue(
            overrideHeaders = params.overrideHeaders,
            pageNumber = params.pageNumber,
            perPage = params.perPage,
            keywords = params.keywords,
            filters = params.filters
        )
    }
}
